import { createRouter, createWebHistory } from 'vue-router'
import layout from '@/layout/index.vue'

const privateRoutes = [
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/chat/index.vue'), // ai
    meta: {
      title: 'chat',
      icon: 'Abi'
    }
  },
  {
    path: '/user',
    component: layout,
    redirect: '/user/manage',
    meta: {
      title: 'user',
      icon: 'personnel'
    },
    children: [
      {
        path: '/user/manage',
        component: () => import('@/views/user-manage/index.vue'), // 用户列表
        meta: {
          title: 'userManage',
          icon: 'personnel-manage'
        }
      },
      {
        path: '/user/role',
        component: () => import('@/views/role-list/index.vue'), // 角色列表
        meta: {
          title: 'roleList',
          icon: 'role'
        }
      },
      {
        path: '/user/permission',
        component: () => import('@/views/permission-list/index.vue'), // 权限列表
        meta: {
          title: 'permissionList',
          icon: 'permission'
        }
      },
      {
        path: '/user/info/:id',
        name: 'userInfo',
        component: () => import('@/views/user-info/index'),
        props: true,
        meta: {
          title: 'userInfo'
        }
      },
      {
        path: '/user/import',
        name: 'import',
        component: () => import('@/views/import/index.vue'), // 导入用户
        meta: {
          title: 'excelImport'
        }
      }
    ]
  },
  {
    path: '/article',
    component: layout,
    redirect: 'article/ranking',
    meta: {
      title: 'article',
      icon: 'article'
    },
    children: [
      {
        path: '/article/ranking',
        component: () => import('@/views/article-ranking/index.vue'), // 文章排名
        meta: {
          title: 'articleRanking',
          icon: 'article-ranking'
        }
      },
      {
        path: '/article/create',
        component: () => import('@/views/article-create/index.vue'), // 创建文章
        meta: {
          title: 'articleCreate',
          icon: 'article-create'
        }
      },
      {
        path: '/article/editor/:id',
        component: () => import('@/views/article-create/index.vue'), // 编辑文章
        meta: {
          title: 'articleEditor'
        }
      },
      {
        path: '/article/:id',
        component: () => import('@/views/article-detail/index.vue'), // 文章详情
        meta: {
          title: 'articleDetail'
        }
      }
    ]
  }
]
const publicRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue') // 登录
  },
  {
    path: '/',
    component: layout,
    redirect: '/profile',
    children: [
      {
        path: '/profile',
        component: () => import('@/views/profile/index.vue'), // 个人中心
        meta: {
          title: 'profile',
          icon: 'personnel'
        }
      },
      {
        path: '/404',
        name: '404',
        component: () => import('@/views/error-page/404.vue') // 404
      },
      {
        path: '/401',
        name: '401',
        component: () => import('@/views/error-page/401.vue') // 401
      },
      {
        path: '/chart',
        name: 'chart',
        component: () => import('@/views/chart/index.vue'), // 图表
        meta: {
          title: 'chart',
          icon: 'chart'
        }
      },
      {
        path: '/ai',
        name: 'ai',
        component: () => import('@/views/ai/index.vue'), // ai
        meta: {
          title: 'ai',
          icon: 'xinghuo'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [...publicRoutes, ...privateRoutes]
})

export default router
